export const getNonce = (length) => {
  // Add timestamp to ensure uniqueness even with same random chars
  const timestamp = Date.now().toString(36);
  const randomLength = Math.max(1, length - timestamp.length);

  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < randomLength; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  // Combine timestamp + random for collision-resistant nonce
  return timestamp + text;
};
